import { render, staticRenderFns } from "./directSection.vue?vue&type=template&id=ed58104e&scoped=true"
import script from "./directSection.vue?vue&type=script&lang=js"
export * from "./directSection.vue?vue&type=script&lang=js"
import style0 from "./directSection.vue?vue&type=style&index=0&id=ed58104e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed58104e",
  null
  
)

export default component.exports